











































































// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// Components
import { DataTable } from '../../table'
import Filters from './Filters.vue'
import { AccordionFilters } from '@/components'

// services
import { LoanControlsService } from '@/services/dailyControl'

// Models
import { Paginator } from '@/models'
import { LoanControlModel, FiltersLoanControl } from '@/models/dailyControl'

// utils
import { getFrecuencyText } from '@/utils'

@Component({
    name: 'TableListLoanControls',
    components: {
        DataTable,
        Filters,
        AccordionFilters
    }
})
export default class TableListLoanControls extends Vue {
    @Prop({ required: true, type: Object }) filters!: FiltersLoanControl
    loading = false
    items: LoanControlModel[] | [] = []
    pagination: Paginator = {
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
    }

    fields = [
        {
            key: 'employee.name',
            sortable: true,
            label: 'Empleado'
        },
        {
            key: 'date',
            sortable: true,
            label: 'Fecha Prestamo'
        },
        {
            key: 'date_start_discount',
            sortable: true,
            label: 'Fecha Inicio Desc.'
        },
        {
            key: 'frequency',
            sortable: true,
            label: 'Frecuencia'
        },
        {
            key: 'dues',
            sortable: true,
            label: 'Cuotas'
        },
        {
            key: 'cuotasg',
            sortable: true,
            label: 'Cuotas Gratificación'
        },
        {
            key: 'amount',
            sortable: true,
            label: 'Importe'
        },
        {
            key: 'balance',
            sortable: true,
            label: 'Saldo'
        },
        {
            key: 'status_text',
            sortable: true,
            label: 'Estado'
        },
        {
            key: 'actions',
            sortable: false,
            label: '',
            thClass: 'one-line w-30',
            thStyle: {
                width: '8%'
            }
        }
    ]

    created () {
        this.getLoanControlsWithPagination()
    }

    getFrecuencyText (key: number): string {
        return getFrecuencyText(key)
    }

    changePage (page: number) {
        this.pagination.currentPage = page
        this.getLoanControlsWithPagination()
    }

    changePerPage (perPage: number) {
        this.pagination.perPage = perPage
        this.pagination.currentPage = 1
        this.getLoanControlsWithPagination()
    }

    getByFilters () {
        this.pagination.currentPage = 1
        this.getLoanControlsWithPagination()
    }

    clearFilters () {
        this.pagination.currentPage = 1
        this.filters.dateStart = null
        this.filters.loanDate = null
        this.filters.employee = null
        this.filters.frequency = null
        this.filters.status = null
        this.getLoanControlsWithPagination()
    }

    async getLoanControlsWithPagination () {
        this.loading = true
        const response = await LoanControlsService.getWithPagination(this.pagination.perPage, this.pagination.currentPage, this.filters)
        this.items = response.objects
        this.pagination = response.pagination
        this.loading = false
    }
}
